import { analytics } from '../../firebase';
import { setUserProperties as fbSetUserProperties, CustomParams } from 'firebase/analytics';

export default function setUserProperties(properties: CustomParams) {
    return fbSetUserProperties(analytics, properties);
}
